import React from 'react'

import {toAbsoluteUrl} from '../../../../../_metronic/helpers'

/**
 * Chatbot mascot (shared by the attendance and FAQ bots). Always the light PNG,
 * regardless of theme: the launcher disc and glass header avatar it sits on keep
 * the same brand-blue in dark mode, so swapping to the dark artwork made the
 * robot look different per theme for no reason. `_transparent` is the supplied
 * `public/chatbot_light_icon.png` with its white background keyed out.
 *
 * The image is clipped by its (relative, overflow-hidden, circular) container and
 * zoomed onto the robot: `CENTER` is where the robot sits in the source (percent)
 * and `SCALE` is the image size relative to the container. It is absolutely
 * positioned so `CENTER` lands on the container's midpoint — no transforms involved.
 */
// Measured from the PNG: robot bbox spans ~41.5% of the frame.
const ICON = {src: '/chatbot_light_icon_transparent.png', center: [50.6, 46.6], scale: 1.8} as const

type AttendanceBotAvatarProps = {
  className?: string
}

const AttendanceBotAvatar: React.FC<AttendanceBotAvatarProps> = ({className = ''}) => {
  const {src, center, scale} = ICON
  const [cx, cy] = center

  return (
    <img
      src={toAbsoluteUrl(src)}
      alt=''
      aria-hidden='true'
      draggable={false}
      className={`chatbot-bot-mascot-img${className ? ` ${className}` : ''}`}
      style={{
        width: `${scale * 100}%`,
        height: `${scale * 100}%`,
        // container midpoint (50%) minus the robot centre, measured in container units
        left: `${50 - cx * scale}%`,
        top: `${50 - cy * scale}%`,
      }}
    />
  )
}

export default AttendanceBotAvatar
